export default "__VITE_ASSET__CnE2ZxHZ__"